import styled from 'styled-components';

import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { spacing } from 'ui/theme';

const RawCountBoxLoadingIcon = ({ height = 128, width = 327, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 327 129" fill="none" {...props}>
    <rect y="0.5" width="327" height="128" rx="4" fill="#F5F4F4" />
    <rect width="164" height="16" transform="translate(24 24.5)" fill="white" />
    <rect x="24" y="24.5" width="164" height="16" rx="4" fill="white" />
    <rect width="231" height="56" transform="translate(24 48.5)" fill="white" />
    <rect x="24" y="48.5" width="231" height="56" rx="4" fill="white" />
  </SvgIcon>
);

export const CountBoxLoadingIcon = styled(RawCountBoxLoadingIcon)`
  margin-left: ${spacing.plusHalf};
`;
